import React from "react";
import "../../Styles/discoverproperty.css";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from "react-router-dom";


const SampleNextArrow = (props) => {

  const { className, style, onClick } = props;
  return (
    <div
      className={className}

      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}

      onClick={onClick}
    />
  );
};

const DiscoverProperty = ({ locationData }) => {
  const navigate = useNavigate()
  const settings = {
    dots: false,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    speed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow className="discover_property_next_arrow" />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const data = [1, 2, 3, 4, 5, 6]

  return (
    <>
      <section className="discover-section">
        <div className="container">
          <div className="row">
            <div className="col-12 property-heading-col">
              <h3>Discover Popular Place</h3>

              <a onClick={() => navigate("/locations")} style={{ cursor: "pointer" }}>
                <h5>
                  View All
                  <span>
                    <img src="/images/btn-arrow.png" alt="Arrow Icon" />
                  </span>
                </h5>
              </a>
            </div>

            <Slider {...settings}>
              {
                locationData && locationData?.map((item, i) => {
                  return <div key={i} className="col-md-4">
                    <div className="discover-property-box" style={{ cursor: "pointer" }} onClick={() => navigate(`/property-listing?location=${item.slug}-${item.id}`)}>
                      <img src={item.image || "/images/arizona.png"} alt="Arizona" />
                      <div className="discover-property-title">
                        <h5>{item.city}</h5>
                        {/* <p>120 Properties</p> */}
                      </div>
                    </div>
                  </div>
                })
              }


            </Slider>

          </div>
        </div>
      </section>
    </>
  );
};

export default DiscoverProperty;
